import WebFontLoader from 'webfontloader';

WebFontLoader.load({
  classes: true,
  custom: {
    families: ['edmunds-icons'],
  },
});
